import { ImageViewer, Image } from 'antd-mobile';
import styles from './index.scss'
import { DEFAULT_IMAGE_TYPE } from './data'
import last from 'lodash/last'

type previewProps = {
  value: any[]
  _valueName?: any[]
  fit?: any
}

export default function DpPreviewViewer(props: previewProps) {
  const MapImage = (mapProps: any = {}) => {
    return props?.value?.map?.((_, key )=> {
      const type: any = last((_?.url || _)?.split('.')); // 
      return (
        <div className={styles['dp-image-preview--item']} key={key}>
          {
            DEFAULT_IMAGE_TYPE?.includes(type) ?
              <Image
                src={_?.url || _}
                width={74}
                height={74}
                fit={props?.fit || 'cover'}
                style={{ borderRadius: 2 }}
                onClick={() => {
                  ImageViewer.Multi.show({
                    images: [_?.url || _],
                    defaultIndex: 0
                  })
                }}
              />
              :
              <a href={_?.url || _} target="_blank" style={{ display: 'inline-block', width: 76, textOverflow: 'ellipsis', wordWrap: 'break-word' }}>{
                // (props?._valueName?.[key]?.name || props?._valueName?.[key]) || _?.url || _
                <Image
                  width={74}
                  height={74}
                  fit={props?.fit || 'cover'}
                  style={{ borderRadius: 2 }}
                  src={'https://oss-images.dragonpass.com.cn/business-saas/website/product/2025-05-22_145044/75a9ff78-3892-4897-b1b6-a637e9ebb3c6.png'} />
              }</a>
          }
        </div>
      )
    })
  }
  return (
    <div className={styles['dp-image-preview']}>
      {MapImage({ width: 96  })}
    </div>
  )
}


